module.exports = __webpack_public_path__ + "img/side-icon-12-off.299457b9.svg";